import React from 'react';
import '../../App.css';
import './Sobremi.css';
import Footer from '../Footer';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { Button } from '../button';
import ThreeColumnWithProfileImage from '../ThreeColumnWithProfileImage';
import {Helmet} from "react-helmet";

function Privacidad () {
    const { Privacidad } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [Privacidad]);

    return (
        <>
         <Helmet>
          <meta charSet='utf-8'/>
          <title>Tekins | Política de Privacidad</title>
          <meta name="description" content= "Detalles sobre la recopilación, uso y protección de datos personales por parte de Tekins." />
          <meta name="robots" content= "index, follow"></meta>
        </Helmet>
        
        <div className='sobre-centro'> 
                   <h1>POLÍTICA DE PRIVACIDAD</h1>

                   <p>La presente Política de Privacidad establece los términos en que Tekins usa y protege la información proporcionada por sus usuarios al momento de utilizar este sitio web. Estamos comprometidos con la seguridad de tus datos. Cuando solicitamos información personal con la cual puedas ser identificado, lo hacemos asegurando que solo se empleará conforme a lo descrito en este documento. Esta política puede actualizarse periódicamente, por lo que recomendamos revisarla con frecuencia para asegurarte de que estás de acuerdo con los cambios.

Información que es recogida

Nuestro sitio web podrá recoger información personal por ejemplo: Nombre,  información de contacto como  su dirección de correo electrónica e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica para procesar algún pedido o realizar una entrega o facturación.

Uso de la información recogida

Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios, de pedidos en caso que aplique, y mejorar nuestros productos y servicios.  Es posible que sean enviados correos electrónicos periódicamente a través de nuestro sitio con ofertas especiales, nuevos productos y otra información publicitaria que consideremos relevante para usted o que pueda brindarle algún beneficio, estos correos electrónicos serán enviados a la dirección que usted proporcione y podrán ser cancelados en cualquier momento.

Tekins está altamente comprometido a mantener tu información segura. Utilizamos controles administrativos, técnicos y físicos para prevenir accesos no autorizados y revisamos periódicamente nuestros procesos.

Cookies

Una cookie es un archivo que se almacena en tu navegador con la finalidad de recordar preferencias y conocer el comportamiento de navegación. Las cookies nos permiten analizar el tráfico del sitio y ofrecerte una experiencia personalizada.

Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su frecuencia. Esta información es empleada únicamente para análisis estadístico y después la información se elimina de forma permanente. Usted puede eliminar las cookies en cualquier momento desde su ordenador. Sin embargo las cookies ayudan a proporcionar un mejor servicio de los sitios web, estás no dan acceso a información de su ordenador ni de usted, a menos de que usted así lo quiera y la proporcione directamente. Usted puede aceptar o negar el uso de cookies, sin embargo la mayoría de navegadores aceptan cookies automáticamente pues sirve para tener un mejor servicio web. También usted puede cambiar la configuración de su ordenador para declinar las cookies. Si se declinan es posible que no pueda utilizar algunos de nuestros servicios.

Enlaces a Terceros

Este sitio web pudiera contener en laces a otros sitios que pudieran ser de su interés. Una vez que usted de clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al que es redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está de acuerdo con estas.

Control de su información personal

En cualquier momento usted puede restringir la recopilación o el uso de la información personal que es proporcionada a nuestro sitio web.  Cada vez que se le solicite rellenar un formulario, como el de alta de usuario, puede marcar o desmarcar la opción de recibir información por correo electrónico.  En caso de que haya marcado la opción de recibir nuestro boletín o publicidad usted puede cancelarla en cualquier momento.

Tekins no venderá, cederá ni distribuirá la información personal recopilada sin tu consentimiento, salvo que sea requerido por una autoridad competente.

Tekins se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.
                  </p>
                      </div>


        <Footer/>
        </>
    );
}

export default Privacidad;
